import { shallowMount } from "@vue/test-utils";
import GraciasEmprendedores from "@/views/GraciasEmprendedores";

describe("GraciasEmprendedores component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(GraciasEmprendedores);
  });

  it("Renders del component GraciasEmprendedores", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
